import { Component, OnInit,ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { IRuleMySuffix } from 'src/app/shared/model/rule-my-suffix.model';
import { Principal } from 'src/app/core';
import { ModalDirective } from 'ngx-bootstrap';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';

@Component({
    selector: 'jhi-rule-my-suffix-detail',
    templateUrl: './open-policy-rule-my-suffix-detail.component.html'
})
export class OpenPolicyRuleMySuffixDetailComponent implements OnInit {
    rule: IRuleMySuffix;
    scopeId: number;
    policyDeductibleType : any;
    isShowPastHistory: boolean;
    isShowFutureHistory: boolean;
    navigableScopeID: any;
    navigableRuleID: any;
    @ViewChild('ruleDraftRelationModal') ruleDraftRelationModal: ModalDirective;


    constructor(private activatedRoute: ActivatedRoute,
         private principal: Principal,
         private router:Router,
         private languageChangeService: LanguageChangeService,) {
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
     }

    ngOnInit() {
        this.principal.setTitle("Rules");
        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.isShowFutureHistory = this.principal.isShowFutureHistory;
        this.scopeId = this.activatedRoute.snapshot.params['scopeId'];

        this.activatedRoute.data.subscribe(({ rule }) => {   
            this.rule = rule;
        });

        if(this.rule.deductableRates.length != 0) {
            let obj : any = {};
            obj = this.rule.deductableRates[0];
            this.policyDeductibleType = this.rule.scopeDeductableType;
        }

        
        this.rule.deductableRates
    }

    previousState() {
        window.history.back();
    }

    get authority() {
        return this.principal.userIdentity.authorities[0];
    }

    // history
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;

    parentHistoryToggle = false;
    parentFutureHistoryToggle = false;
    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
        this.parentFutureHistoryToggle = $event;
    }

    viewHistory(ruleObj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Rule History';
        this.historyType = "RULE_AUDIT";
        this.historyId = ruleObj.id;
    }

    viewFutureHistory(ruleObj) {
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Rule Future Records';
        this.historyType = "RULE_AUDIT";
        this.historyId = ruleObj.id;
    }
   
    hideRuleDraftRelationModal(){
        this.ruleDraftRelationModal.hide()
    }
    navigateRuleSuffix(){
        this.router.navigate(['/rule-my-suffix',this.navigableRuleID, this.navigableScopeID, 'edit'])
    }
    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            this.parentFutureHistoryToggle = false;
        }
    }
}
